module.exports = __webpack_public_path__ + "img/news_1.e09b6ecb.png";